<template lang="pug">
    v-container.default-container
        .points-container
            .points-backround(v-if="bgIcon" style="pointer-events: none")
                font-awesome-icon.bgIcon(:icon="bgIcon" v-bind:style="bgIconStyle")
            h2 {{title}}
            h3 {{subTitle}}
            div(v-for="point in points" style="max-width: 750px")
                div
                    td
                        font-awesome-icon(:icon="listIcon" size="2x" v-bind:style="{ color: listIconColor, 'padding-top': 7 + 'px' }")
                    td
                        b
                            p.ml-5(style="margin-bottom: 0.5em !important;") {{point.title}}
                        p.ml-5 {{point.subTitle}}
            p(v-if="note" style="margin-top: 5em") * 
                u {{note}}
</template>

<script>
    export default {
        name: 'Points',
        props: {
            title: {
                type: String, 
                required: true
            },
            subTitle: {
                type: String, 
                required: false
            },
            points: {
                type: Array,
                required: true
            },
            note: {
                type: String,
                required: false
            },
            listIcon: {
                type: Array, 
                required: true
            },
            listIconColor: {
                type: String,
                required:false
            },
            bgIcon :{ 
                type: Array, 
                required: false
            },
            bgIconStyle: {
                type: Object,
                required: false
            }
        },
        data: () => ({
        }),
    }
</script>

<style lang="stylus" scoped>
h2
    margin-bottom  0.5em

h3
    margin-bottom  3em

.points-container
    position relative

.points-backround
    position absolute
    display flex
    align-content center
    align-items center
    justify-content center
    height: 100%
    width: 100%

.bgIcon 
    //color: rgba(255,255,255, 0.35) !important

    margin-left: 1000px 
    height: auto
    

@media (max-width: 1150px) {
    .bgIcon {
        display: none
    }
}

@media (min-width: 1150px) {
    .bgIcon {

        margin-left: 1200px !important
    }
}
@media (min-width: 1264px) {
    .bgIcon {
        margin-left: 1000px !important
    }
}
</style>
